module.exports = __webpack_public_path__ + "static/media/edit-pen.b69d1df3.svg";